import ClientSummaryHandler from "../../services/ClientSummary";

export default {
    async loadClientSummaries({commit, dispatch}, payload) {
        const {data} = await ClientSummaryHandler.all(payload);

        commit('SET_CLIENT_SUMMARY', data);
    }
}
